import { PAYMENT_GEO_URL } from 'lib/paymentApi/constants';
import { CookieService } from '@/app_lib/CookieService';
import type { RegistrationSource } from '@/app_lib/types/accounts/piano/Piano';

export async function geoIp(
  pianoUid: string,
  registrationSource: RegistrationSource,
  accessToken?: string,
): Promise<void> {
  const pianoUserToken = accessToken || CookieService.get('__utp') || '';
  await fetch(`${PAYMENT_GEO_URL}?pianoUID=${pianoUid}&registrationSource=${registrationSource}`, {
    headers: {
      'user-token': pianoUserToken,
    },
  })
    .then((response) => response.json())
    .then((data) => {
      // biome-ignore lint/suspicious/noConsole: This is for debugging purposes
      console.info('Success:', data);
    })
    .catch((error) => {
      // biome-ignore lint/suspicious/noConsole: This is for debugging purposes
      console.error('Error:', error);
    });
}
